import React from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";

import AcUnitIcon from "@mui/icons-material/AcUnit";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import LocalFloristIcon from "@mui/icons-material/LocalFlorist";
import SpaIcon from "@mui/icons-material/Spa";
import WbSunnyIcon from "@mui/icons-material/WbSunny";

function replaceColors(gradient) {
  return gradient;
}

function gradientFromColorArray(colors) {
  let backgroundImage = "";
  if (colors.length <= 0) {
    return;
  }
  // if one color, then duplicate it
  if (colors.length === 1) {
    colors = colors.concat(colors);
  }

  // if lilac is in the array, replace it with purple
  if (colors.includes("lilac")) {
    colors[colors.indexOf("lilac")] = "purple";
  }
  //if deep blue
  if (colors.includes("Deep blue")) {
    colors[colors.indexOf("Deep blue")] = "#00008B";
  }
  // if Lavender
  if (colors.includes("lavender")) {
    colors[colors.indexOf("lavender")] = "#E6E6FA";
  }

  // combine the colors into css gradient with 0 to 100% for each color
  let colorPercentage = 100 / colors.length;

  let gradient = "";
  // for each color
  for (let i = 0; i < colors.length; i++) {
    // first color
    let firstColor = colors[i];
    // second color
    let secondColor = colors[i + 1];
    if (i == 0) {
      gradient = `${gradient} ${firstColor} ${colorPercentage * i}%,`;
      gradient = `${gradient} ${firstColor} ${colorPercentage * (i + 1)}%,`;
    } else if (i < colors.length - 1) {
      // add the color to the gradient
      gradient = `${gradient} ${firstColor} ${colorPercentage * i}%,`;
      gradient = `${gradient} ${firstColor} ${colorPercentage * (i + 1)}%,`;
      gradient = `${gradient} ${secondColor} ${colorPercentage * (i + 1)}%,`;
    } else {
      // add the last color
      gradient = `${gradient} ${firstColor} 100%`;
    }
  }
  return gradient;
}

const Color = ({ plants, allPlants, title = "" }) => {
  const getSeasonIcon = (season, color) => {
    // combine the colors into css gradient
    let backgroundImage = "";
    if (color.length > 0) {
      backgroundImage = `linear-gradient(90deg, ${gradientFromColorArray(
        color
      )})`;
      color = "black";
    } else {
      color = "grey";
    }

    let colorStyle = {
      backgroundImage: replaceColors(backgroundImage),
      color: color,
      borderRadius: "25%",
    };

    switch (season) {
      case "Spring":
        return <LocalFloristIcon style={colorStyle} />;
      case "Summer":
        return <WbSunnyIcon style={colorStyle} />;
      case "Autumn":
        return <SpaIcon style={colorStyle} />;
      case "Winter":
        return <AcUnitIcon style={colorStyle} />;
      default:
        return null;
    }
  };

  let colorSpring = [];
  let colorSummer = [];
  let colorAutumn = [];
  let colorWinter = [];

  // go through each plant
  plants.forEach((plant) => {
    // get the plant data
    let plantData = allPlants.find((p) => p.name === plant.name);
    // check if the plant has a color in each season
    let colors = plantData.flowerColor;
    if (colors) {
      colors = colors.split("/");
      let floweringTime = plantData.floweringTime;

      // check the array for each season and add the color to the array
      if (floweringTime.includes("Spring")) {
        colorSpring = colorSpring.concat(colors);
      }
      if (floweringTime.includes("Summer")) {
        colorSummer = colorSummer.concat(colors);
      }
      if (floweringTime.includes("Autumn")) {
        colorAutumn = colorAutumn.concat(colors);
      }
      if (floweringTime.includes("Winter")) {
        colorWinter = colorWinter.concat(colors);
      }
    }
  });
  // console.log(colorSpring);
  // console.log(colorSummer);
  // console.log(colorAutumn);
  // console.log(colorWinter);

  // remove duplicates
  colorSpring = [...new Set(colorSpring)];
  colorSummer = [...new Set(colorSummer)];
  colorAutumn = [...new Set(colorAutumn)];
  colorWinter = [...new Set(colorWinter)];

  return (
    <Box>
      <Typography variant="h6">{title}</Typography>
      <Stack spacing={1} direction={"row"}>
        {getSeasonIcon("Spring", colorSpring)}
        {getSeasonIcon("Summer", colorSummer)}
        {getSeasonIcon("Autumn", colorAutumn)}
        {getSeasonIcon("Winter", colorWinter)}
      </Stack>
    </Box>
  );
};

export default Color;
